<template>
  <el-row v-loading.fullscreen.lock="fullScreenLoading">
    <el-col
      :sm="{ span: 14, offset: 5 }"
      :md="{ span: 12, offset: 6 }"
      :lg="{ span: 12, offset: 6 }"
    >
      <el-header
        height="140px"
        class="app-header pt-50 pb-30"
      >
        <Menu />
        <h3 class="app-header-title mt-0">
          {{ $t("organization.create-team") }}
        </h3>
      </el-header>
      <el-main>
        <el-form
          :model="team"
          :rules="getFormRules"
          ref="createTeamForm"
          label-position="top"
        >
          <el-form-item
            :label="$t('organization.name')"
            prop="name"
          >
            <el-input v-model="team.name" />
          </el-form-item>
          <el-form-item
            :label="$t('team.showTeamName')"
            prop="showsTeamName"
          >
            <el-switch v-model="team.showsTeamName" />
          </el-form-item>
          <el-form-item
            :label="$t('team.hideOnSelectTeamPage')"
            prop="hideOnSelectTeamPage"
          >
            <el-switch v-model="team.hideOnSelectTeamPage" />
          </el-form-item>
          <el-form-item
            :label="$t('organization.type-sharing-tips.title')"
            prop="sharingType"
          >
            <el-select v-model="team.sharingType">
              <el-option
                :label="$t('organization.type-sharing-tips.options.individual')"
                value="Individual"
              />
              <el-option
                :label="$t('organization.type-sharing-tips.options.pooling')"
                value="Pooling"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('teams.group-qr-code')"
            prop="qrCode"
          >
            <el-input-number
              :controls="false"
              v-model="team.qrCode"
            />
          </el-form-item>
          <el-form-item
            :label="$t('organization.defined-amount')"
            prop="defTipsAmount"
          >
            <defined-tips-repeater
              prop="defTipsAmount"
              :fields="team.defTipsAmount"
              @change-radio="changeRadio"
            />
          </el-form-item>
          <el-form-item
            :label="$t('organization.defined-percent')"
            prop="defTipsPercentage"
          >
            <defined-tips-repeater
              prop="defTipsPercentage"
              :fields="team.defTipsPercentage"
              @change-radio="changeRadio"
            />
          </el-form-item>
          <el-form-item class="mt-20">
            <el-row>
              <el-col :span="11">
                <router-link
                  :to="{
                    name: 'Organization',
                    params: { id: $route.params.id },
                  }"
                  custom
                  v-slot="{ navigate }"
                >
                  <el-button
                    class="cancel-button"
                    @click="navigate"
                  >
                    {{ $t("form.cancel") }}
                  </el-button>
                </router-link>
              </el-col>
              <el-col
                :offset="2"
                :span="11"
              >
                <el-button
                  class="primary-button"
                  type="primary"
                  @click="submitForm('createTeamForm')"
                >
                  {{ $t("form.save") }}
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-main>
    </el-col>
  </el-row>
</template>

<script>
import Menu from "@/views/Menu/Menu";
import DefinedTipsRepeater from "../Components/Repeaters/DefinedTipsRepeater";

export default {
  name: "CreateTeam",
  components: {
    Menu,
    DefinedTipsRepeater,
  },
  data: () => ({
    fullScreenLoading: false,
    team: {
      name: "",
      showsTeamName: false,
      hideOnSelectTeamPage: false,
      sharingType: "",
      qrCode: null,
      defTipsAmount: [
        { value: 5, checked: false },
        { value: 8, checked: true },
        { value: 10, checked: false },
        { value: 12, checked: false },
      ],
      defTipsPercentage: [
        {
          value: 10,
          checked: false,
        },
      ],
    },
  }),
  computed: {
    getFormRules: function() {
      const defaultValueValidator = (rule, value, callback) => {
        let defaultValid = false;
        let validValues = true;
        value.map((el) => {
          if (el.checked) {
            defaultValid = true;
          }
          if (!el.value) {
            validValues = false;
          }
        });
        if (!validValues) {
          callback(new Error(this.$t("form.validation.all-items-populated")));
        }
        if (!defaultValid) {
          callback(new Error(this.$t("form.validation.one-item-default")));
        }
        callback();
      };
      return {
        name: [
          {
            required: true,
            message: this.$t("form.validation.required", {
              field: this.$t("organization.name"),
            }),
            trigger: "blur",
          },
        ],
        sharingType: [
          {
            required: true,
            message: this.$t("form.validation.required", {
              field: this.$t("teams.sharing-type"),
            }),
            trigger: "blur",
          },
        ],
        defTipsAmount: [{ validator: defaultValueValidator }],
        defTipsPercentage: [{ validator: defaultValueValidator }],
      };
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.createTeam();
        } else {
          return false;
        }
      });
    },
    createTeam() {
      this.$adminApi
        .post("/api/v1/entities/teams", {
          beUid: this.$route.params.id,
          name: this.team.name,
          sharingType: this.team.sharingType,
          qrCode: this.team.qrCode,
          defTipsAmount: this.team.defTipsAmount,
          defTipsPercentage: this.team.defTipsPercentage,
        })
        .then((response) => {
          if (response.data.status === "Success") {
            this.$message.success(
              this.$t("form.item-created", {
                item: this.$t("re-conciliation.choose-team.team"),
              })
            );
            this.$router.push({
              name: "Organization",
              params: { id: this.$route.params.id },
            });
          } else if (response.data.status === "Duplicates") {
            this.$message.warning(
              this.$t("teams.team-exist", { name: this.team.name })
            );
          } else {
            this.$message.warning(response.data.status);
          }
        })
        .catch(() => {
          this.$message.error(this.$t("form.something-wrong"));
        });
    },
    changeRadio(field) {
      this.$refs["createTeamForm"].validateField(field);
    },
  },
};
</script>

<style scoped></style>
